import { PaymentsApi } from '../../api';
import axios from '../axios';

const paymentApi = new PaymentsApi(undefined, undefined, axios);

export default paymentApi;
